export default __webpack_public_path__ + "3d009e9e28398dbd78773b1823305ceb.png";